import { useContext } from "react";

import { ToastContext } from "../states/toastContext";

const useToast = () => {
    const { state, dispatch } = useContext(ToastContext);

    const error = (content: any) => {
        const id = new Date();
        dispatch({
            type: "addToast",
            value: { content: content, type: "error", id },
        });
    };
    const success = (content: any) => {
        const id = new Date();
        dispatch({
            type: "addToast",
            value: { content: content, type: "success", id },
        });
    };
    const warning = (content: any) => {
        const id = new Date();
        dispatch({
            type: "addToast",
            value: { content: content, type: "warning", id },
        });
    };
    const clearById = (id: any) => {
        dispatch({
            type: "clearToast",
            value: id,
        });
    };
    const clearByIndex = (index: any) => {
        dispatch({
            type: "clearToast",
            value: index,
        });
    };
    const clearAll = () => {
        dispatch({
            type: "clearAllToast",
        });
    };

    return {
        error,
        success,
        warning,
        clearAll,
        clearByIndex,
        clearById,
        state,
        dispatch,
    };
};

export default useToast;
